

export const intersectionObserverEmits = () => ([
  "onProductIntersect"
])

export const useIntersectionObserver = (context) => {
  const onIntersect = (entries, observer) => {
    entries.forEach(({ target, isIntersecting }) => {
      if (!isIntersecting) {
        return;
      }
      observer.unobserve(target);
      const i = target.getAttribute("data-index");
      context.emit("onProductIntersect", i);
    });
  };

  return { onIntersect };
}